import type { GraphEdgeSettingsStyle } from '../graphSettings';

/**
 * Transforms number of edges in a group into its `weight` property
 */
export function getEdgeThickness(
  thicknessThresholds: GraphEdgeSettingsStyle['thicknessThresholds'],
  numberOfEdges: number,
): number {
  for (let i = 0; i < thicknessThresholds.length; i += 1) {
    const thicknessThreshold = thicknessThresholds[i];
    if (thicknessThreshold === undefined) {
      // Undefined value skipped to keep previous behavior after introducing noUncheckedIndexArrayAccess.
      // Better error handling is encouraged in the future.
      continue;
    }

    if (numberOfEdges <= thicknessThreshold) {
      return i + 1;
    }
  }

  return thicknessThresholds.length + 1;
}
